// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Password-module-inputWrap-Lx6_7{position:relative}.Password-module-icon-Nv_q-{position:absolute;top:50%;transform:translateY(-50%);margin-inline-start:-35px;cursor:pointer;height:18px;width:18px;color:#373a36}.Password-module-input-1pjb9{padding-inline-end:40px}.Password-module-requirementWrapper-3wEAg{margin-block-start:var(--des-dimension-gap-and-padding-field-between-label-and-box)}", ""]);
// Exports
exports.locals = {
	"inputWrap": "Password-module-inputWrap-Lx6_7",
	"icon": "Password-module-icon-Nv_q-",
	"input": "Password-module-input-1pjb9",
	"requirementWrapper": "Password-module-requirementWrapper-3wEAg"
};
module.exports = exports;
